<ng-container [caLocalizationScope]="localizationScope">
  <i
    class="f-i f-i-modified-data text-muted"
    [ngClass]="[iconClass, iconSizeClass]"
    [ngbTooltip]="tooltipContent"
    [container]="container"
    data-automation-id="crm-field-icon"
  >
  </i>
  <ng-template #tooltipContent>
    <span>{{ 'crmFieldIconTooltip' | caLocalize }}</span>
  </ng-template>
</ng-container>
